import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import './BankAccountChoices.css';

const { FiCopy, FiCheck } = FiIcons;

async function copyToClipboard(value) {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(value);
    return;
  }

  const field = document.createElement('textarea');
  field.value = value;
  field.style.position = 'fixed';
  field.style.opacity = '0';
  document.body.appendChild(field);
  field.select();
  const copied = document.execCommand('copy');
  field.remove();

  if (!copied) throw new Error('Clipboard copy failed');
}

export default function BankAccountChoices({ accounts, selectedId, onSelect, amount }) {
  const [copiedField, setCopiedField] = useState('');
  const selected = accounts.find((account) => account.id === selectedId) || accounts[0];

  const handleCopy = async (value, field) => {
    try {
      await copyToClipboard(value);
      setCopiedField(field);
      window.setTimeout(() => setCopiedField(''), 1800);
    } catch (error) {
      console.error('Could not copy bank details:', error);
    }
  };

  const copyButton = (value, field, label) => (
    <button
      type="button"
      className="bank-copy-button"
      onClick={() => handleCopy(value, field)}
      aria-label={`Copy ${label}`}
      title={`Copy ${label}`}
    >
      <SafeIcon icon={copiedField === field ? FiCheck : FiCopy} />
    </button>
  );

  return (
    <>
      {accounts.length > 1 && (
        <div className="bank-choice-list" role="radiogroup" aria-label="Choose a bank account">
          {accounts.map((account) => (
            <label className={`bank-choice ${selected?.id === account.id ? 'selected' : ''}`} key={account.id}>
              <input
                type="radio"
                name="transfer-account"
                value={account.id}
                checked={selected?.id === account.id}
                onChange={() => onSelect(account.id)}
              />
              {account.logo_url && <img src={account.logo_url} alt="" />}
              <span>
                <strong>{account.bank_name}</strong>
                <small>Account ending {account.account_number.slice(-4)}</small>
              </span>
            </label>
          ))}
        </div>
      )}
      {selected && (
        <div className="bank-info">
          <div><span>Bank</span><strong>{selected.bank_name}</strong></div>
          <div className="bank-info-copy-row">
            <span>Account Name</span>
            <div className="bank-copy-value">
              <strong>{selected.account_name}</strong>
              {copyButton(selected.account_name, 'account-name', 'account name')}
            </div>
          </div>
          <div className="bank-info-copy-row">
            <span>Account Number</span>
            <div className="bank-copy-value">
              <strong>{selected.account_number}</strong>
              {copyButton(selected.account_number, 'account-number', 'account number')}
            </div>
          </div>
          <div><span>Branch</span><strong>{selected.branch}</strong></div>
          <div><span>Amount</span><strong className="bank-amount">Rs. {amount.toLocaleString()}</strong></div>
        </div>
      )}
    </>
  );
}